import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DropdownOption } from '@maced/angular-components/lib/dropdown/dropdown.model';
import { Subscription } from 'rxjs';

const MOBILE_VIEW_WIDTH: number = 800;

interface IndicatorModel {
  colorCode: string;
  name: string;
  borderColor: string;
  status: string;
  label: string;
  value: number,
  statusUrl: string
};

@Component({
  selector: 'app-action-card',
  templateUrl: './action-card.component.html'
})
export class ActionCardComponent implements OnInit, OnDestroy {
  private window: Window;
  public actionCardId1: string = 'actionCard-1';
  public title1: string = 'Card name';
  public iconAltText1: string = "icon alt text for action card";
  public iconClass: string = 'icon-check-circle';
  public iconTitle: string = "Completed";
  public iconUrl: string = '../../assets/images/mme_logo.svg';
  public showAccordian: boolean = false;
  public showIconClass: boolean = true;
  public showIconImage: boolean = false;
  public hasIconClass: boolean = true;
  private queryParamSubscription!: Subscription;
  private list: Array<number> = [1, 2, 3, 4];

  public options: DropdownOption[] = this.list.map((i: number) => {
    return {
      id: 'option4' + i,
      name: 'option4' + i,
      label: 'option 4' + i,
      url: '/action-card'
    };
  });

  public dummyList: Array<{ [key: string]: any }> = this.list.map((i: number) => {
    return {
      label: 'label' + i,
      value: 'value' + i,
      link: {
        label: 'link' + i,
        hyperLink: '/action-card',
        target: '_self'
      }
    };
  });

  public indicatorList: Array<IndicatorModel> = [{
    colorCode: '#C038A4',
    name: 'Magenta',
    borderColor: '#E6AFDB',
    status: 'Not started yet',
    label: 'Not started yet',
    value: 0,
    statusUrl: '/action-card'
  },
  {
    colorCode: '#915AB7',
    name: 'Purple',
    borderColor: '#D3BDE2',
    status: 'Not completed',
    label: 'Not completed',
    value: 0,
    statusUrl: '/action-card'
  },
  {
    colorCode: '#994D2B',
    name: 'Orange',
    borderColor: '#FFCCB6',
    status: 'Awaiting grading',
    label: 'Awaiting grading',
    value: 0,
    statusUrl: '/action-card'
  },
  {
    colorCode: '#0D842F',
    name: 'Green',
    borderColor: '#9ECEAC',
    status: 'Complete',
    label: 'Complete',
    value: 0,
    statusUrl: '/action-card'
  }];

  public isBrowser: boolean = true;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) public platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    } else {
      this.isBrowser = false;
    }
    this.window = this.document.defaultView!;
  }

  ngOnInit(): void {
    this.queryParamSubscription = this.route.queryParams.subscribe(param => {
      if (param.dropdownId && param.dropdownId === 'dropdownId1') {
        this.options.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
          } else {
            obj.active = false;
          }
        });
      }

      if (!this.isBrowser) {
        this.showAccordian = param.showAccordian === 'on';
        this.showIconClass = param.showIconClass === 'on';
        this.showIconImage = param.showIconImage === 'on'
        this.hasIconClass = param.hasIconClass === 'on'
      }
    });
    if (this.isBrowser) {
      this.shouldShowAccordian();
    }
  }

  @HostListener('window:resize', ['$event'])
  shouldShowAccordian(): void {
    if (this.window) {
      this.showAccordian = this.window.innerWidth < MOBILE_VIEW_WIDTH;
    }
  }

  ngOnDestroy(): void {
    if (this.queryParamSubscription) {
      this.queryParamSubscription.unsubscribe();
    }
  }
}